export const shareIconIdPrefix = 'share-button--';

export const shareButtonName = {
    facebook: shareIconIdPrefix + 'facebook',
    odnoklassniki: shareIconIdPrefix + 'odnoklassniki',
    telegram: shareIconIdPrefix + 'telegram',
    twitter: shareIconIdPrefix + 'twitter',
    viber: shareIconIdPrefix + 'viber',
    vkontakte: shareIconIdPrefix + 'vkontakte',
    whatsApp: shareIconIdPrefix + 'whats-app',
} as const;
